import Brad from "./Brad.png";
import Vicki from "./Vicki.png";
import Liz from "./Liz.png";
import Gary from "./Gary.png";

const teamMembers = [
  {
    name: "Brad Sykes",
    title: "CO-FOUNDER",
    img: Brad,
    email: "bsykes2819@gmail.com",
    phone: "904.328.9617",
    slug: "brad-sykes",
  },
  {
    name: "Vicki Sykes",
    title: "CO-FOUNDER",
    img: Vicki,
    email: "vicki.sykes@att.net",
    phone: "904.772.5970",
    slug: "vicki-sykes",
  },
];

export default teamMembers;
